import { useToast } from "@agney/ir-toast";
import { IonGrid, IonPage, IonRow, IonContent } from "@ionic/react";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Call from "../../components/Shared/Call/call";
import Loader from "../../components/Shared/Loader/Loader";
import { utilService } from "../../services";
import BedCard from "./components/BedCard";
import "./UnitBeds.scss";
import { BedDataObject, ProcessedBedsData } from "./UnitBedsDataModel";
import { UnitBedsService } from "./UnitBedsService";
import { useTranslation } from "react-i18next";

interface PropsInterface {
  location: {
    state: any;
  };
}

const UnitBeds: React.FunctionComponent<PropsInterface> = (
  props: PropsInterface
) => {
    const { t } = useTranslation("sites");
  let history = useHistory();
  const Toast = useToast();

  const [bedsList, setBedsList]: [ProcessedBedsData, Function] = useState(
    {} as ProcessedBedsData
  );
  const [showLoader, setShowLoader]: [boolean, Function] = useState(false);
  const [unitId, setUnitId]: any = useState();

  useEffect(() => {
    getBedsData();
  }, []);

  const updateBedList = (bedData: BedDataObject) => {
    const newBedList = bedsList.bedsData.map((element) =>
      element.id === bedData.id
        ? { ...element, is_active: bedData.is_active }
        : element
    );
    setBedsList({ ...bedsList, bedsData: newBedList });
  };

  const getBedsData = async () => {
    const currentDate = new Date();
    const reqParams = {
      unitId: UnitBedsService.getUnitId(),
      hour: currentDate.getHours(),
      minute: currentDate.getMinutes(),
      date: `${currentDate.getFullYear()}-${
        currentDate.getMonth() + 1
      }-${currentDate.getDate()}`,
      reg_code: utilService.getNetwork(),
      page: 1,
    };
    setShowLoader(true);
    const bedsResponse: ProcessedBedsData = await UnitBedsService.getBeds(
      reqParams
    );
    if (bedsResponse.isSuccess) {
      setBedsList(bedsResponse);
      setUnitId(bedsResponse.unitData.unitId);
    } else {
      Toast.error(bedsResponse.message);
    }
    setShowLoader(false);
  };

  const setDataToCall = (source: string) => {
    const returnObj: any = {};
    returnObj.callTo = source;
    if (source === "sites") {
      if (!isEmpty(bedsList.siteData?.contactDetails)) {
        returnObj.contactNumber = bedsList.siteData?.contactDetails[0].number;
      }
      returnObj.name = bedsList.siteData?.siteName;
    } else if (source === "units") {
      if (!isEmpty(bedsList.unitData?.contactDetails)) {
        returnObj.contactNumber = bedsList.unitData?.contactDetails[0].number;
      }
      returnObj.name = bedsList.unitData?.unitName;
    }
    return returnObj;
  };

  return (
    <IonPage>
      <IonContent>
        {showLoader && (
          <div className="loader-container">
            <Loader></Loader>
          </div>
        )}
        <div className="unit-beds-container">
          <div className="back-button-container d-flex align-items-center pb-3 justify-content-between">
            <div className="d-flex align-items-center">
              <button
                className="icon-back icon p-0"
                onClick={() => history.goBack()}
              ></button>
              <span className="ml-2">{`${
                props.location?.state?.siteName
                  ? props.location?.state?.siteName
                  : ""
              }  `}</span>
              {(bedsList.unitData || bedsList.siteData) && (
                <span className="ml-2">{`${
                  bedsList?.unitData?.location
                    ? bedsList?.unitData?.location
                    : ""
                } | ${bedsList?.siteData?.location}`}</span>
              )}
            </div>
            <div className="call-site-unit-btn-container">
              <Call
                selectedDoctorGuid=""
                dataFromParent={setDataToCall("sites")}
                isAssignedNumber={true}
                isCallButton={true}
               callButtonText={t("callSite")}
              ></Call>
              <Call
                selectedDoctorGuid=""
                dataFromParent={setDataToCall("units")}
                isAssignedNumber={true}
                isCallButton={true}
               callButtonText={t("callUnit")}
              ></Call>
            </div>
          </div>
          <IonGrid>
            <IonRow className="bedcard-list-container">
              {bedsList?.bedsData?.length !== 0 ? (
                bedsList?.bedsData?.map((bedObj: BedDataObject) => (
                  <BedCard
                    key={bedObj.id}
                    bedData={bedObj}
                    setBedsList={setBedsList}
                    updateBedList={updateBedList}
                    unitId={unitId}
                  />
                ))
              ) : (
             <p className="text-center p-3">{t("noBedsAvailable")}</p>
              )}
            </IonRow>
          </IonGrid>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default UnitBeds;
